import React from 'react'
import ReactTooltip from 'react-tooltip'

function Tooltip() {
  return <ReactTooltip effect='solid' />
}

export default Tooltip
